import { render, staticRenderFns } from "./RequiredTag.vue?vue&type=template&id=4db91f14&"
import script from "./RequiredTag.vue?vue&type=script&lang=js&"
export * from "./RequiredTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports